import { Routes, RouterModule } from '@angular/router';
import { SplashComponent } from '../splash/splash.component';
import { HeaderComponent } from '../header/header.component';
import { LogoutComponent } from '../logout/logout.component';
import { LogoutSSOComponent } from '../logout/logoutsso.component';
import { LoginComponent, DashboardHome, StatusReportComponent, ExperienceReportComponent, SSOLoginComponent } from '../viewsmodule/views';
import { DEFAULT_PATH, LOGIN, LOGOUT_PATH, DASHBOARDS } from '../utils/utils';
import { AuthGuard } from '../_guards/auth.guard'

const appRoutes: Routes = [

    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'sso/:token/:title/:search',
        component: SSOLoginComponent
    },
    {
        path: DASHBOARDS,
        component: DashboardHome,
        canActivate: [AuthGuard]
    },
    {
        path: 'statusReport/:id',
        component: StatusReportComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'experienceReport/:id',
        component: ExperienceReportComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'splash',
        component: SplashComponent
    },
    {
        path: LOGOUT_PATH,
        component: LogoutComponent
    },
    {
        path: 'ssologout',
        component: LogoutSSOComponent
    },
    {
        path: '',
        redirectTo: DASHBOARDS,
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: 'login'
    }
]

export const routing = RouterModule.forRoot(appRoutes, { useHash: true });


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/boot/app.routing.ts